import { render, staticRenderFns } from "./ReturnedChecksInHands.vue?vue&type=template&id=35595376"
import script from "./ReturnedChecksInHands.vue?vue&type=script&lang=js"
export * from "./ReturnedChecksInHands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports